module.exports = __webpack_public_path__ + "static/media/img_text_benchmarking.58baa4e2.png";